import templateUrl from 'emun.auth/users/user-calendar-auth.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import ServiceBus from 'servicestack/service-bus'
import User from 'emun.auth/users/user.model'
import $session from 'servicestack/session'

class controller {
    constructor() {
        const $ctrl = this;
        basicController($ctrl)
		$ctrl.bus = new ServiceBus();
		$ctrl.authorizing = false;
    }

    $onInit() {
        const $ctrl = this;
	}

	startPolling() {
		const $ctrl = this;

		setTimeout(function () {
			$ctrl.bus.send('QueryUsers.json?Id=' + $ctrl.request.id).then(response => {
				var u = new User(response.data.results[0]);
				if (u.meta.cronofyToken) {
					$ctrl.authorizing = false;
					$ctrl.request.meta.cronofyToken = u.meta.cronofyToken;
					$ctrl.request.meta.cronofyRefreshToken = u.meta.cronofyRefreshToken;
					$ctrl.request.meta.cronofyCalId = u.meta.cronofyCalId;
					$ctrl.request.meta.cronofyNotificationChannel = u.meta.cronofyNotificationChannel;
				} else {
					$ctrl.startPolling();
				}
			});
		}, 10000);
	}

	userAuthorize() {
		let $ctrl = this;
		if ($session.isCronofyEnterprise()) {
			$ctrl.bus.send('AuthorizeUser.json', { username: $ctrl.request.userName });
			$ctrl.authorizing = true;
			$ctrl.startPolling();
		} else {
			$ctrl.bus.send('GetAuthorizationUrl.json', { username: $ctrl.request.userName }).then(function (response) {
				window.location = response.data + "&state=" + $ctrl.request.userName;
			});
		}
	}

}

let component = {
    bindings: {
        request: '='
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default component;
